import { __spreadArrays } from "tslib";
import { RsvpStatus } from '../enums/rsvp';
export var getAvatars = function (members, totalGuests, isRsvp, maxAvatars, isMembersVisibleInEditor) {
    if (members === void 0) { members = []; }
    if (isMembersVisibleInEditor && !members.length && !totalGuests) {
        return [{}, {}];
    }
    var memberAvatars = getMemberAvatars(members, isRsvp);
    return __spreadArrays(memberAvatars, getAnonymousAvatars(totalGuests, maxAvatars, memberAvatars.length));
};
var getMemberAvatars = function (members, isRsvp) {
    if (members === void 0) { members = []; }
    if (isRsvp) {
        members = members.filter(function (member) { return member.rsvpStatus === RsvpStatus.YES; });
    }
    return members.map(function (member) { return ({
        name: member.nickname,
        src: member.imageUrl,
    }); });
};
var getAnonymousAvatars = function (totalGuests, maxAvatars, memberCount) {
    var total = getTotalAttendingGuests(totalGuests);
    var neededAvatarCount = Math.min(maxAvatars, total);
    var anonymousAvatars = [];
    while (anonymousAvatars.length < neededAvatarCount - memberCount) {
        anonymousAvatars.push({});
    }
    return anonymousAvatars;
};
export var getExtraGuestsCount = function (totalGuests, maxAvatars) {
    var total = getTotalAttendingGuests(totalGuests) - maxAvatars;
    return total > 0 ? total : 0;
};
var getTotalAttendingGuests = function (totalGuests) {
    return typeof totalGuests === 'number' ? totalGuests : totalGuests.YES || 0;
};
export var hasGuestsGoing = function (totalGuests, isRsvp) { var _a; return isRsvp ? !!((_a = totalGuests === null || totalGuests === void 0 ? void 0 : totalGuests.YES) !== null && _a !== void 0 ? _a : 0) : !!totalGuests; };
//# sourceMappingURL=members.js.map